module.exports = __webpack_public_path__ + "static/img/img_kaifaanli2.84557596.png";